<div
  class="small-round-button"
  [ngClass]="buttonClass"
  [class.selected]="selected"
  (click)="buttonClick.emit()">
  @if (icon) {
    <span class="material-icons">{{ icon }}</span>
  }
  @if (image) {
    <tidy-image [src]="image" class="button-icon" />
  }
</div>
